/**
 * 获取路由信息
 */
export const getRouterItems = (state: any) => {
    return state.routerItems && state.routerItems.length > 0
    ? state.routerItems
        : JSON.parse(localStorage.getItem('dynRoutes')||'[]')
}
